/**
 * Pharmacy Order Data Model
 * Medication orders sent to pharmacy providers
 */

export const ORDER_STATUS = {
  PENDING_APPROVAL: 'Pending Approval',
  SENT: 'Sent to Pharmacy',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  PACKED: 'Packed',
  DISPATCHED: 'Dispatched',
  DELIVERED: 'Delivered',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};

export const ORDER_PRIORITY = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  URGENT: 'Urgent'
};

export const createOrderItem = (data = {}) => ({
  id: data.id || `OI-${Date.now()}-${Math.random().toString(36).substr(2, 4)}`,
  drug: data.drug || '',
  genericName: data.genericName || '',
  strength: data.strength || '',
  qty: data.qty || 0,
  repeatsRemaining: data.repeatsRemaining || 0,
  pbsEligible: Boolean(data.pbsEligible),
  authority: Boolean(data.authority),
  authorityNumber: data.authorityNumber || null
});

export const createPharmacyOrder = (data = {}) => {
  const now = new Date().toISOString();
  return {
    id: data.id || `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
    facilityId: data.facilityId || data.facility || null,
    wardId: data.wardId || null,
    ward: data.ward || '',
    residentId: data.residentId || null,
    residentName: data.residentName || '',
    pharmacy: data.pharmacy || '',
    pharmacyId: data.pharmacyId || null,

    items: (data.items || []).map(i => createOrderItem(i)),

    status: data.status || ORDER_STATUS.PENDING_APPROVAL,
    priority: data.priority || ORDER_PRIORITY.MEDIUM,
    slaHours: data.slaHours || 48,

    prescriberId: data.prescriberId || null,
    prescriberName: data.prescriberName || '',
    approvedBy: data.approvedBy || null,
    approvedAt: data.approvedAt || null,

    notes: data.notes || '',
    trackingNumber: data.trackingNumber || null,
    deliveredAt: data.deliveredAt || null,

    createdAt: data.createdAt || now,
    updatedAt: data.updatedAt || now
  };
};

export default {
  createPharmacyOrder, createOrderItem,
  ORDER_STATUS, ORDER_PRIORITY
};
